import PropTypes from "prop-types";
import DropdownSingleSelectWithoutSearch from "shared/components/inputs/dropdown/DropdownSingleSelectWithoutSearch";
import FormInputWrapper from "../form/FormInputWrapper";
import { useFormInput } from "./utils";

const Dropdown = ({
    name,
    validations,
    label,
    description,
    helpText,
    className,
    isSmallSize,
    disabled = false,
    onChange = () => void 0,
    ...rest
}) => {
    const { wrapperProps, inputProps } = useFormInput({
        name,
        validations,
        isControlled: true,
    });

    const feedbackMessageData =
        !inputProps?.value && wrapperProps?.feedbackMessage;

    return (
        <FormInputWrapper
            {...{ label, description, helpText, className, isSmallSize }}
            {...wrapperProps}
            feedbackMessage={feedbackMessageData}
            disabled={disabled}
        >
            <DropdownSingleSelectWithoutSearch
                {...rest}
                {...inputProps}
                onSelectedValue={onChange(inputProps?.value)}
                feedbackMessage={feedbackMessageData}
                disabled={disabled}
                isSmallSize={isSmallSize}
            />
        </FormInputWrapper>
    );
};

Dropdown.propTypes = {
    name: PropTypes.string.isRequired,
    validations: PropTypes.object,
    label: PropTypes.string,
    description: PropTypes.string,
    helpText: PropTypes.string,
    className: PropTypes.string,
    isSmallSize: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
};

export default Dropdown;
